

























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { ContentCampaignItemStatus } from '@/modules/content-campaign/models/content-campaign-resource.model'

@Component
export default class ContentCampaignItemsCountByStatus extends Vue {
  @Prop({ required: true }) readonly items_count!: { [key in ContentCampaignItemStatus]: string }
  @Prop({ default: 0 }) readonly total_counts!: number

  get pending_counts() {
    return this.items_count[ContentCampaignItemStatus.PENDING]
  }

  get queue_counts() {
    return this.items_count[ContentCampaignItemStatus.QUEUE]
  }

  get editing_counts() {
    return this.items_count[ContentCampaignItemStatus.EDITING]
  }

  get completed_counts() {
    return this.items_count[ContentCampaignItemStatus.COMPLETED]
  }
}
